import { QueryConfig } from "store/utils/query-config";

export const metaCustomAudiencesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
